import { render, staticRenderFns } from "./AddressItem.vue?vue&type=template&id=34484a8b&scoped=true"
import script from "./AddressItem.vue?vue&type=script&lang=js"
export * from "./AddressItem.vue?vue&type=script&lang=js"
import style0 from "./AddressItem.vue?vue&type=style&index=0&id=34484a8b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34484a8b",
  null
  
)

export default component.exports